<template>
  <div class="message">
    <p>{{ dialogData.content }}</p>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { DIALOG_OPTION } from '../../store/mutation-types'
export default {
  props: {
    dialogData: {
      type: Object,
      default: function() {
        return {}
      },
    },
  },
  mounted() {
    setTimeout(() => {
      this.btnCancel()
    }, 1200)
  },
  methods: {
    ...mapMutations([DIALOG_OPTION]),
    btnCancel() {
      //取消
      this.$store.commit(DIALOG_OPTION, {
        dialogTableVisible: false,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/base.scss';
.message {
  width: 606px;
  height: 419px;
  margin: 0 auto;
  font-size: 18px;
  color: #a5a7bf;
  text-align: center;
  position: relative;
  background-image: url('https://img.dota2.com.cn/file/64/5c/645cad6ff11c5759c9ea10ff2e4d771e1596523283.png');
  > p {
    position: absolute;
    width: 100%;
    left: 0;
    top: 45%;
    color: #a5a7bf;
  }
  .maps-msg {
    padding-top: 120px;
    p {
      color: #a5a7bf;
      margin-bottom: 90px;
      /deep/ span {
        color: #ffd27d;
      }
    }
  }
}
</style>
